import * as React from "react";
import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";

import { cn } from "../lib/utils";
import { Button } from "./Button";
import { Calendar } from "./Calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./Popover";

export function DatePicker() {
  const [date, setDate] = React.useState<Date>();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={"outline-with-icon"}
          className={cn(
            "tw-figr-w-[280px] tw-figr-justify-start tw-figr-text-left tw-figr-font-normal",
            !date && "tw-figr-text-neutral-500"
          )}
        >
          <CalendarIcon className="tw-figr-mr-s tw-figr-h-4 tw-figr-w-4" />
          {date ? format(date, "PPP") : <span>Pick a date</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="tw-figr-w-auto tw-figr-p-0">
        <Calendar
          mode="single"
          selected={date}
          onSelect={setDate}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
